/* eslint-disable */
import React from "react";
import AllUsers from "../../components/AllUsers/AllUsers";
import PaperComponent from "../../components/PaperComponent/PaperComponent";

export default function AllUsersPage() {
  return <PaperComponent children={<AllUsers />} />;
}
